export type TUsStateCode =
  | 'AA'
  | 'AE'
  | 'AL'
  | 'AK'
  | 'AP'
  | 'AS'
  | 'AZ'
  | 'AR'
  | 'CA'
  | 'CO'
  | 'CT'
  | 'DE'
  | 'DC'
  | 'FL'
  | 'GA'
  | 'GU'
  | 'HI'
  | 'ID'
  | 'IL'
  | 'IN'
  | 'IA'
  | 'KS'
  | 'KY'
  | 'LA'
  | 'ME'
  | 'MD'
  | 'MA'
  | 'MI'
  | 'MN'
  | 'MS'
  | 'MO'
  | 'MT'
  | 'NE'
  | 'NV'
  | 'NH'
  | 'NJ'
  | 'NM'
  | 'NY'
  | 'NC'
  | 'ND'
  | 'MP'
  | 'OH'
  | 'OK'
  | 'OR'
  | 'PA'
  | 'PR'
  | 'RI'
  | 'SC'
  | 'SD'
  | 'TN'
  | 'TX'
  | 'VI'
  | 'UT'
  | 'VT'
  | 'VA'
  | 'WA'
  | 'WV'
  | 'WI'
  | 'WY';

export interface IUsState {
  abbreviation: TUsStateCode;
  fullName: string;
}

export const US_STATES: IUsState[] = [
  { abbreviation: 'AA', fullName: 'Armed Forces Americas (except Canada)' },
  { abbreviation: 'AE', fullName: 'Armed Forces Europe, the Middle East, and Canada' },
  { abbreviation: 'AL', fullName: 'Alabama' },
  { abbreviation: 'AK', fullName: 'Alaska' },
  { abbreviation: 'AS', fullName: 'American Samoa' },
  { abbreviation: 'AZ', fullName: 'Arizona' },
  { abbreviation: 'AP', fullName: 'Armed Forces Pacific' },
  { abbreviation: 'AR', fullName: 'Arkansas' },
  { abbreviation: 'CA', fullName: 'California' },
  { abbreviation: 'CO', fullName: 'Colorado' },
  { abbreviation: 'CT', fullName: 'Connecticut' },
  { abbreviation: 'DE', fullName: 'Delaware' },
  { abbreviation: 'DC', fullName: 'District of Columbia' },
  { abbreviation: 'FL', fullName: 'Florida' },
  { abbreviation: 'GA', fullName: 'Georgia' },
  { abbreviation: 'GU', fullName: 'Guam' },
  { abbreviation: 'HI', fullName: 'Hawaii' },
  { abbreviation: 'ID', fullName: 'Idaho' },
  { abbreviation: 'IL', fullName: 'Illinois' },
  { abbreviation: 'IN', fullName: 'Indiana' },
  { abbreviation: 'IA', fullName: 'Iowa' },
  { abbreviation: 'KS', fullName: 'Kansas' },
  { abbreviation: 'KY', fullName: 'Kentucky' },
  { abbreviation: 'LA', fullName: 'Louisiana' },
  { abbreviation: 'ME', fullName: 'Maine' },
  { abbreviation: 'MD', fullName: 'Maryland' },
  { abbreviation: 'MA', fullName: 'Massachusetts' },
  { abbreviation: 'MI', fullName: 'Michigan' },
  { abbreviation: 'MN', fullName: 'Minnesota' },
  { abbreviation: 'MS', fullName: 'Mississippi' },
  { abbreviation: 'MO', fullName: 'Missouri' },
  { abbreviation: 'MT', fullName: 'Montana' },
  { abbreviation: 'NE', fullName: 'Nebraska' },
  { abbreviation: 'NV', fullName: 'Nevada' },
  { abbreviation: 'NH', fullName: 'New Hampshire' },
  { abbreviation: 'NJ', fullName: 'New Jersey' },
  { abbreviation: 'NM', fullName: 'New Mexico' },
  { abbreviation: 'NY', fullName: 'New York' },
  { abbreviation: 'NC', fullName: 'North Carolina' },
  { abbreviation: 'ND', fullName: 'North Dakota' },
  { abbreviation: 'MP', fullName: 'Northern Mariana Islands' },
  { abbreviation: 'OH', fullName: 'Ohio' },
  { abbreviation: 'OK', fullName: 'Oklahoma' },
  { abbreviation: 'OR', fullName: 'Oregon' },
  { abbreviation: 'PA', fullName: 'Pennsylvania' },
  { abbreviation: 'PR', fullName: 'Puerto Rico' },
  { abbreviation: 'RI', fullName: 'Rhode Island' },
  { abbreviation: 'SC', fullName: 'South Carolina' },
  { abbreviation: 'SD', fullName: 'South Dakota' },
  { abbreviation: 'TN', fullName: 'Tennessee' },
  { abbreviation: 'TX', fullName: 'Texas' },
  { abbreviation: 'VI', fullName: 'U.S. Virgin Islands' },
  { abbreviation: 'UT', fullName: 'Utah' },
  { abbreviation: 'VT', fullName: 'Vermont' },
  { abbreviation: 'VA', fullName: 'Virginia' },
  { abbreviation: 'WA', fullName: 'Washington' },
  { abbreviation: 'WV', fullName: 'West Virginia' },
  { abbreviation: 'WI', fullName: 'Wisconsin' },
  { abbreviation: 'WY', fullName: 'Wyoming' },
  /**
   * Areas that have 2-letter codes but are deliberately omitted because they are
   * outside the US: Federated States of Micronesia, Marshall Islands, and Palau.
   * Areas that are not states but are deliberately included because they are
   * part of the US: American Samoa, District of Columbia, Guam, Northern
   * Mariana Islands, Puerto Rico, Virgin Islands (U.S.).
   */
];

export const US_TERRITORIES: TUsStateCode[] = ['AS', 'GU', 'MP', 'PR', 'VI'];
